import { render, staticRenderFns } from "./sendOut.vue?vue&type=template&id=0884b81d&scoped=true&"
import script from "./sendOut.vue?vue&type=script&lang=js&"
export * from "./sendOut.vue?vue&type=script&lang=js&"
import style0 from "./sendOut.vue?vue&type=style&index=0&id=0884b81d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884b81d",
  null
  
)

export default component.exports